const baseStyle = {
  fontWeight: 'bold',
  lineHeight: 1.2,
};

export default {
  baseStyle,
};
